import { Image } from 'shared/types';
import { cn } from 'shared/utils/cn';

export interface HostCardProps {
  image?: Image;
  name: string;
  role: string;
  bio: string;
  className?: string;
}

export function HostCard({ image, name, role, bio, className }: HostCardProps) {
  return (
    <div
      className={cn('group bg-surface-container-low p-8 rounded-xl hover:bg-surface-bright transition-all duration-500 flex flex-col items-center text-center', className)}
    >
      <div className="w-48 h-48 rounded-full overflow-hidden mb-8 shadow-2xl transition-transform group-hover:scale-105">
        {image ? (
          <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-secondary-container" />
        )}
      </div>
      <h3 className="font-serif text-2xl mb-2 text-on-surface">{name}</h3>
      <span className="font-sans text-tertiary text-xs uppercase tracking-widest mb-6">
        {role}
      </span>
      <p className="font-sans text-sm text-on-surface-variant leading-relaxed">{bio}</p>
    </div>
  );
}
